import { AppShell, Loading, useMedplum } from "@medplum/react";
import { MEDPLUM_VERSION } from "@medplum/core";
import { useLocation, useSearchParams } from "react-router-dom";
import { Suspense, useEffect, useState } from "react";
import { AppRoutes } from "./AppRoutes";
import WellULogo from "./assets/img/healthConnectLogo.jpeg";
import Logo from "./assets/img/healthConnectLogo1.svg";
import { Box, Title, createStyles } from "@mantine/core";
import dashboard from "./assets/img/dashboard.svg";
import accessPolicy from "./assets/img/accesspolicy.svg";
import diagnostic from "./assets/img/diagnostic.svg";
import visits from "./assets/img/visits.svg";
import notes from "./assets/img/notes.svg";
import appointments from "./assets/img/appointments.svg";
import medications from "./assets/img/medications.svg";
import practioner from "./assets/img/practioner.svg";
import questionnare from "./assets/img/Question.svg";
import patient from "./assets/img/patient.svg";
import Integrationsicon from "./assets/img/setting.svg";
import FhirLogo from "./assets/img/fluent-mdl2_calories.svg";
import eligibilityIcon from "./assets/img/Eligibiltynew.svg";
import bulkExport from "./assets/img/bULKeXPORT.svg";
import hl7Svg from "./assets/img/hl7.svg";
import { useDispatch } from "react-redux";
import { updateProfile } from "./store/actions/ProfileActions";
import AistarSvg from "../src/assets/img/mdi-star2.svg";
import voiceSvg from "../src/assets/img/voice.svg";

const excludeAuthUrl = [
  "/healthconnect-ai",
  "/healthconnect-form",
  "/healthconnect-chat",
  "/healthconnect-referral",
  "/healthconnect-epic",
  "/healthconnect-ai-careplan",


  "/launch",
];

const useStyles = createStyles(() => ({
  altAppLogo: {
    height: "50px",
    width: "100px",
    marginTop: "-10px ",
    marginLeft: "-10px",
  },
  appLogo: {
    width: "45%",
  },

  sideNavIcon: {
    height: "24px",
    width: "24px",
    marginRight: "16px",
  },
  projectLogo: {
    height: "50px",
    maxWidth: "100%",
  },
  demoFor: {
    maxWidth: "100%",
    position: "fixed",
    bottom: "50px",
    left: "50px",
  },
}));

export function App(): JSX.Element {
  const dispatch = useDispatch();
  const medplum = useMedplum();
  const config = medplum.getUserConfiguration();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const { classes } = useStyles();
  const profile = medplum.getProfile();
  const project = medplum.getProject();
  const [projectLogo, setProjectLogo] = useState("");
  const [isAltLogo, setIsAltLogo] = useState(false);
  const [isEmbed, setIsEmbed] = useState(false);

  useEffect(() => {
    if (
      excludeAuthUrl.filter((url) => location.pathname.includes(url)).length ===
      0
    ) {
      setIsEmbed(true);
    }
  }, []);
  // useEffect(() => {
  //   // Check if the current URL contains "smarit health"
  //   if (location.pathname.includes("smart-it")) {
  //     // Redirect to YouTube
  //     window.open(
  //       "https://apps.smarthealthit.org/app/healthconnect-patient-referral",
  //       "_blank"
  //     );
  //   }
  // }, [location]);

  useEffect(() => {
    if (project) {
      getProjectDetails();
      dispatch(updateProfile(profile));
      if (
        profile &&
        (profile?.name?.[0]?.given?.[0] == "Anupam" ||
          profile?.name?.[0]?.given?.[0] == "WellU")
      ) {
        setIsAltLogo(true);
      }
    }
  }, [project]);

  const getProjectDetails = () => {
    medplum
      .readResource(project?.resourceType!, `${project?.id}`)
      .then((res: any) => {
        setProjectLogo(res?.secret?.[0]?.valueString || "");
      })
      .catch((err) => {
        console.error({ err });
      });
  };
  if (medplum.isLoading()) {
    return <Loading />;
  }

  const ProjectLogo = () => {
    return (
      <Box className={classes.demoFor}>
        {projectLogo && (
          <>
            <Title>Demo For</Title>
            <img src={projectLogo} className={classes.projectLogo} />
          </>
        )}
      </Box>
    );
  };

  function getUserConfiguration() {
    const navItems = [
      {
        links: [
          {
            label: "Dashboard",
            href: "admin/dashboard",
            icon: <img src={dashboard} className={classes.sideNavIcon} />,
          },
          {
            label: "Patients",
            href: "/Patient",
            icon: <img src={patient} className={classes.sideNavIcon} />,
          },
          {
            label: "Insurance",
            href: "admin/insurance",
            icon: (
              <Box>
                <img
                  style={{ height: "20px" }}
                  src={eligibilityIcon}
                  className={classes.sideNavIcon}
                />
              </Box>
            ),
          },
          {
            label: "AI Recipes",
            href: "admin/ai-recipes",
            icon: (
              <img
                style={{ height: "20px" }}
                src={AistarSvg}
                className={classes.sideNavIcon}
              />
            ),
          },
          {
            label: "QConnect AI",
            href: "admin/voice-assist-ai",
            icon: (
              <img
                style={{ height: "20px" }}
                src={voiceSvg}
                className={classes.sideNavIcon}
              />
            ),
          },
          {
            label: "Integrations",
            href: "admin/Integration",
            icon: (
              <img src={Integrationsicon} className={classes.sideNavIcon} />
            ),
          },
          {
            label: "HL7 Interface",
            href: "admin/hl7-trigger",
            icon: (
              <img
                style={{ height: "20px" }}
                src={hl7Svg}
                className={classes.sideNavIcon}
              />
            ),
          },

          {
            label: "FHIR Bulk Export",
            href: "admin/bulk-export",
            icon: (
              <img
                style={{ height: "20px" }}
                src={bulkExport}
                className={classes.sideNavIcon}
              />
            ),
          },

          // {
          //   label: "Appointments",
          //   href: "admin/appointments",
          //   icon: <img src={appointments} className={classes.sideNavIcon} />,
          // },
          // {
          //   label: "Medications",
          //   href: "admin/medications",
          //   icon: <img src={medications} className={classes.sideNavIcon} />,
          // },
          // {
          //   label: "Diagnostic Reports",
          //   href: "admin/diagnosticreport",
          //   icon: <img src={diagnostic} className={classes.sideNavIcon} />,
          // },

          // {
          //   label: "Clinical Notes",
          //   href: "admin/Clinical_notes",
          //   icon: <img src={notes} className={classes.sideNavIcon} />,
          // },
          {
            label: "FHIR Capabilities",
            href: "admin/fhircapabilities",
            icon: (
              <img
                style={{ height: "20px" }}
                src={FhirLogo}
                className={classes.sideNavIcon}
              />
            ),
          },
          {
            label: "Smart On FHIR Apps",
            href: "/admin/smartonfhir-apps",
            icon: (
              <img
                style={{ height: "20px" }}
                src={FhirLogo}
                className={classes.sideNavIcon}
              />
            ),
          },

          {
            label: "Audit Events",
            href: "admin/audit-events",
            icon: (
              <img
                style={{ height: "20px" }}
                src={notes}
                className={classes.sideNavIcon}
              />
            ),
          },

          {
            label: "",
            href: "#",
            icon: <ProjectLogo />,
          },
        ],
      },
    ];

    if (profile?.resourceType === "Patient") {
      navItems[0].links.splice(3, 0, {
        label: "Practitioner",
        href: "admin/Practitioner",
        icon: <img src={practioner} className={classes.sideNavIcon} />,
      });
      navItems[0]?.links.push({
        label: "Access policy",
        href: "admin/Accesspolicy",
        icon: <img src={accessPolicy} className={classes.sideNavIcon} />,
      });
    }
    return navItems;
  }

  return (
    <>
      {isEmbed ? (
        <AppShell
          logo={
            <Box
              component={"img"}
              src={isAltLogo ? WellULogo : Logo}
              className={isAltLogo ? classes.altAppLogo : classes.appLogo}
            />
          }
          pathname={location.pathname}
          searchParams={searchParams}
          version={MEDPLUM_VERSION}
          displayAddBookmark={!!config?.id}
          menus={getUserConfiguration()}
          headerSearchDisabled={true}
          resourceTypeSearchDisabled={true}
        >
          <Suspense fallback={<Loading />}>
            <AppRoutes />
          </Suspense>
        </AppShell>
      ) : (
        <Suspense fallback={<Loading />}>
          <AppRoutes />
        </Suspense>
      )}
    </>
  );
}
